<template>
    <div class="loginbg" style="display: none;">
        <div class="container">
            <div class="row">
                <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                    <div class="loginform">
                        <div class="loginlogo">
                            <img src="static/images/login-logo.png" alt="Velocity Vehicle Group">
                        </div>
                        <form>
                            <!--
                            <div class="form-group">
                                <label v-if="isEmail == 'undefined'" for="exampleInputEmail1">Dayforce ID / Email</label>
                                <label v-else-if="isEmail == true" for="exampleInputEmail1">Email</label>
                                <label v-else for="exampleInputEmail1">Dayforce ID</label>
                                <input v-model="username" type="text" name="username" class="form-control" id="username_login" placeholder="Enter Username">
                                <span class="help is-danger">{{username_error_msg}}</span>
                            </div>

                            <div class="form-group">
                                <label for="exampleInputPassword1">Password</label>
                                <input v-model="password" type="password" name="password" class="form-control" id="password_login" placeholder="Enter password">
                                <span class="help is-danger">{{password_error_msg}}</span>
                            </div>

                            <div>
                                <button id="loginbtn" type="submit" class="btn btn-primary" v-on:click.prevent="login(this)">Login</button>
                                <a :href="forgot_pass_url" target="_blank">Forgot password?</a>
                            </div>
                            -->
                            <label class="checkbox-inline checkbox-bootstrap checkbox-lg">
                                    Logout from (<a v-bind:href="ssoDomainUrl">{{ssoDomainUrl}}</a>),If You are not able to login please clear Cookies and login again.
                                    Please contact admin if you are still not able to Login.
                            </label>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="si-login-bg-main-section">
        <div class="si-login-left-section"></div>
        <div class="si-logo">
            <a href="#">
                <img src="/static/images/si-vvg-home-logo.png" alt="Velocity Vehicle Group">
            </a>
        </div>
        <div class="si-login-right-main-section">
            <div class="si-login-r-left-section">
                <img src="/static/images/si-service.png" alt="Login Welcome Img"> 
                <p class="si-text"> Welcome to <br/> Service Intranet </p>
            </div>
            <div class="si-login-form-right-section">
                <form>
                    <div class="form-group">
                        <label for="exampleInputEmail1">Dayforce Id</label>
                        <input type="text" v-validate="'required'" v-model="username" name="username" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter Dayforce Id">
                        <span v-show="errors.has('username')" class="help is-danger">{{ errors.first('username') }}</span>
                    </div>
                    <div class="form-group">
                        <label for="exampleInputPassword1">Password</label>
                        <input type="password" v-validate="'required'" v-model="password" name="password" class="form-control" id="exampleInputPassword1" placeholder="Enter password">
                        <span v-show="errors.has('password')" class="help is-danger">{{ errors.first('password') }}</span>
                        <div class="help is-danger">{{login_err_msg}}</div>
                        <font class="text-danger"> <label  id="errorMsg" class="error text-danger" v-model="error"></label><br> </font>
                    </div>
                    <div class="si-button-section">
                        <button type="submit" class="btn btn-primary hvr-sweep-to-right" v-on:click.prevent="login(this)">Login</button>
                        <a class="btn btn-primary hvr-sweep-to-right" :href="register_url" target="_blank"> Not Registered? Sign up</a>
                    </div>
                    <div class="si-forgot-password">
                        <a :href="forgot_pass_url" target="_blank">Forgot password?</a>
                    </div>
                </form>
            </div>
        </div>
    </div> -->
</template>
<script>

    import Vue from 'vue';
    import EventBus from './event-bus.js';
    import {HTTP} from '../http-common';
    import {commonMixins} from '../mixins/commonMixins';
    import {frontDomain,ssoDomain,autologinuser} from '../../config';
    var self;
    export default {
        name: 'Login',
        mixins: [commonMixins],
        data() {
            return {
                error : "",
                isEmail: "undefined",
                username: "",
                password: "",
                login_err_msg: "",
                forgot_pass_url: "",
                remember_me: false,
                /* sign_up_url: "", */
                forgot_pass_url: "",
                register_url: "",
                username_error_msg: "",
                password_error_msg: "",
                ssoDomainUrl : "",
            }
        },
        watch: {
            username: function (username) {
                if (username == '') {
                    self.isEmail = 'undefined';
                } else {
                    self.isEmail = self.validEmail(username);
                }
            },
        },
        created: function () {

        },
        beforeMount: function () {
            console.log("Before Mount");
            self = this;
            self.ssoDomainUrl = process.env.SSO_ROOT_URL;
            console.log(self.ssoDomainUrl);
            console.log(self.$route.query);
            
            if(self.$route.query.redirect == "false") {
                // DO NOTHING
            } else {
                if(self.$route.query.token) {
                    window.localStorage.setItem("access_token", self.$route.query.token);
                    window.localStorage.setItem("username", self.$route.query.username);
                    self.autoLoginUser(self.$route.query.username);
                } else {
                    var api_token = localStorage.getItem("access_token");
                    if(api_token == null) {
                        $(".loginbg").show();
                        window.location.href = process.env.SSO_ROOT_URL + "/login?redirect=" + process.env.FRONT_ROOT_URL + '&slug=' + process.env.PROJECT_SLUG;
                    } else {
                        self.getFirstMenu();
                    }
                }
            }
            
        },
        mounted: function () {
            /* var self = this;
            self.forgot_pass_url = process.env.HR_URL + "forgotpassword?identify=" + window.location.href;
            self.register_url = process.env.HR_URL + "register?identify=" + window.location.href;
            self.username = self.getCookie('sales_username');
            self.password = self.getCookie('sales_password');
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                self.getFirstMenu();
            } else {
                $(".loginbg").show();
            }
            $(document).ready(function () {
                $('#rememberMe').change(function () {
                    if (this.checked) {
                        self.remember_me = true;
                    } else {
                        self.remember_me = false;
                    }
                });
            }); */
        },
        methods: {

            setCookie: function (cname, cvalue, exdays) {
                var d = new Date();
                d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
                var expires = "expires=" + d.toUTCString();
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
            },
            getCookie: function (cname) {
                var name = cname + "=";
                var decodedCookie = decodeURIComponent(document.cookie);
                var ca = decodedCookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return "";
            },
            getFirstMenu: function () {
                var self = this;
                HTTP.get("get_first_menu", [])
                        .then(function (response) {
                            if (response.data.code == 200) {
                                //console.log(JSON.stringify(response.data.content.slug));
                                window.location.href = "/" + response.data.content.slug;
                            }
                        })
                        .catch(function (err) {
                            //console.log(err);
                            self.catchHandler(err, function () {

                            });
                        });
            },
            notRegisterUser: function () {
                window.open(self.register_url);
            },
            autoLoginUser: function (username) {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("access_token")}
                };
                var fields = {
                    'username': username,
                    'access_token': window.localStorage.getItem('access_token')
                };
                HTTP.post("autologinuser", fields)
                    .then(function (data) {
                        if (data.status == 200) {
                            localStorage.setItem("user_role", data.data.content.roles.system_id);
                            localStorage.setItem("token", data.data.content.api_token);
                            localStorage.setItem("user_obj", JSON.stringify(data.data.content.user_obj));
                            EventBus.$emit('logged-in', true,
                                data.data.content.user_obj["first_name"],
                                data.data.content.user_obj["last_name"],
                                data.data.content.user_obj["username"],
                                data.data.content.user_obj["username"],
                            );
                            window.location.href = "/" + data.data.content.menu.slug;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        // self.login_err_msg = error.response.data.message;
                    })
            },
            login: function () {
                $("#errorMsg").html('');
                //debugger
                var self = this;
                var error = false;
                self.username_error_msg = '';
                self.password_error_msg = '';

                if (!self.username || self.username == null || self.username == "") {
                    self.username_error_msg = "The username field is required.";
                    error = true;
                }

                if (!self.password || self.password == null || self.password == "") {
                    self.password_error_msg = "The password field is required.";
                    error = true;
                }

                if (!error) {
                    $('#loginbtn').text("Login...");
                    $("#loginbtn").attr("disable", true);

                    var fields = {
                        username: self.username,
                        password: self.password
                    };

                    HTTP.post("login", fields)
                        .then(function (data) {

                            $('#loginbtn').text("Login");
                            $("#loginbtn").attr("disable", false);

                            if (data.status == 200) {
                                console.log("here in login method");
                                localStorage.setItem("user_role", data.data.content.roles.id);
                                localStorage.setItem("token", data.data.content.api_token);
                                localStorage.setItem("user_obj", JSON.stringify(data.data.content.user_obj));
                                EventBus.$emit('logged-in',
                                        true,
                                        data.data.content.user_obj["first_name"],
                                        data.data.content.user_obj["last_name"],
                                        data.data.content.user_obj["email"],
                                        data.data.content.user_obj["username"],
                                        );
                                if (self.remember_me) {
                                    /*self.setCookie('vvg_sso_auth_token', data.data.content.api_token, 365);*/
                                    self.setCookie('sales_username', self.username, 365);
                                    self.setCookie('sales_password', self.password, 365);
                                } else {
                                    self.setCookie('sales_username', '', 365);
                                    self.setCookie('sales_password', '', 365);
                                }
                                /*$.cookie('username', self.username, {expires: 365});
                                    $.cookie('password', self.password, {expires: 365});*/
                                window.location.href = "/" + data.data.content.menu.slug;
                            } else {
                                $("#errorMsg").html(data.data.content);
                                if (data.data.content.length > 0) {
                                    var err = "";
                                    err += data.data.content + "<br>";
                                    $("#errorMsg").html(err);
                                }
                            }
                                /*if (data.status == 201) {
                                
                                self.server_name = data.data.content.user.name;
                                self.server_address = data.data.content.user.address;
                                self.server_email = data.data.content.user.email;
                                self.server_pass = data.data.content.user.password;
                                self.server_mobile = data.data.content.user.mobileno;
                                }*/ 
                        })
                        .catch(function (error) {

                            $('#loginbtn').text("Login");
                            $("#loginbtn").attr("disable", false);
                            //console.log(error);
                            // self.login_err_msg = error.response.data.message;
                            self.password_error_msg = error.response.data.message;
                        })
                }
            },
        }
    }
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Login.vue